import { API } from "@/API/main";

const prefix = '/admin'


const getUsers = () => {
    return API(localStorage.getItem('userToken')).get(`${prefix}/employees`)
}
const getUser = (id) => {
    return API(localStorage.getItem('userToken')).get(`${prefix}/employees/${id}`)
}

const patchUser = (data) => {
    return API(localStorage.getItem('userToken')).patch(`${prefix}/employees`, { ...data })
}
const deleteUser = (id) => {
    return API(localStorage.getItem('userToken')).delete(`${prefix}/employees/${id}`)
}

export { patchUser, getUsers, getUser, deleteUser }
